import React from 'react';
import ReactDOM from 'react-dom';
import VoucherWithDynamicPrice from '../../Components/Cart/Components/Voucher/VoucherWithDynamicPrice';
import Voucher, { VoucherFromDom } from '../../Components/Cart/Components/Voucher/VoucherActions';

const voucherIntegrationContainer = document.querySelectorAll('.js-voucher-actions') as NodeListOf<HTMLElement>;

const VoucherIntegration: React.FunctionComponent = () => {
    if (voucherIntegrationContainer.length > 0) {
        return (
            <>
                {[...voucherIntegrationContainer].map((container) => {
                    const article: VoucherFromDom = JSON.parse(container.dataset.article as string);
                    if (article.type === 'voucher') {
                        return ReactDOM.createPortal(<Voucher article={article} />, container);
                    } else if (article.type === 'voucherWithDynamicPrice') {
                        return ReactDOM.createPortal(<VoucherWithDynamicPrice article={article} />, container);
                    }
                })}
            </>
        );
    }

    return null;
};

export default VoucherIntegration;
